import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Program from './pages/Program';
import News from './pages/News';

function App() {
  return (
    <Router>
      <div className="app-container">
        <Navbar />

        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/program" element={<Program />} />
            <Route path="/news" element={<News />} />
          </Routes>
        </main>

        <footer className="footer bg-dark">
          <div className="container">
            <div className="footer-brand-block">
              <h2 className="footer-logo">OSSCE</h2>
              <p className="footer-fullname">
                Oxford Society for Science Communication and Engagement
              </p>
            </div>
            <div className="footer-grid">
              <div className="footer-col">
                <a href="/">HOME</a>
                <a href="/about">ABOUT US</a>
              </div>
              <div className="footer-col">
                <a href="/program">PROGRAMME</a>
                <a href="/news">NEWS</a>
              </div>
            </div>
            <div className="footer-socials">
              <a href="https://www.linkedin.com/company/ossce/" className="footer-social-link" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                  <rect x="2" y="9" width="4" height="12" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
              </a>

              <a href="http://facebook.com/people/Oxford-Society-for-Science-Communication-and-Engagement/61577961763695/" className="footer-social-link" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                </svg>
              </a>

              <a href="https://www.instagram.com/oxscicom/" className="footer-social-link" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                </svg>
              </a>

              <a href="mailto:ossce-coms@proton.me" className="footer-social-link" aria-label="Email">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="4" width="20" height="16" rx="2" />
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                </svg>
              </a>

              <a href="https://bsky.app/profile/ossce.bsky.social" className="footer-social-link" aria-label="Bluesky" target="_blank" rel="noopener noreferrer">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.879.135 2.593 0 4.102 0 5.344c0 1.242.66 9.879.99 10.999.989 3.36 4.608 4.221 7.828 3.518-4.708 1.498-5.834 4.549-3.284 7.153 3.238 3.307 5.76-1.577 6.466-4.57.706 2.993 3.228 7.877 6.466 4.57 2.55-2.604 1.424-5.655-3.284-7.153 3.22.703 6.839-.158 7.828-3.518.33-1.12.99-9.757.99-10.999 0-1.242-.135-2.751-.902-3.465-.659-.613-1.664-.935-4.3 1.026-2.752 1.942-5.711 5.881-6.798 7.995z" />
                </svg>
              </a>

              <a href="https://chat.whatsapp.com/BSK3ysnUDiJ9xMg0KA1O22" className="footer-social-link" aria-label="WhatsApp" target="_blank" rel="noopener noreferrer">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                </svg>
              </a>
            </div>
            <p className="copyright">© 2026 Oxford Society for Science Communication and Engagement</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
